import React from "react";
import "./PageFooter.scss";
import LanguageSelector from "../LanguageSelector";
import Text from "../Text";
import Dropdown from "react-bootstrap/Dropdown";
import { withRoleVisibility } from "../RoleVisibilityManager";
import MediaQuery from "react-responsive";
import classNames from "classnames";

function ServiceScreenButtonComponent() {
    return (
        <a id="service-button" className="footer-right" href="/#/service">
            <Text value="SERVICE" />
        </a>
    );
}

const ServiceScreenButton = withRoleVisibility(
    ServiceScreenButtonComponent,
    "service-screen",
    o => o.read,
    o => o.read
);

const PageFooter = props => {
    let mainClassName = classNames({
        "page-footer": true,
        "page-footer-when-expanded": !!props.expanded,
        "page-footer-when-collapsed": !props.expanded,
    });
    return (
        <div className={mainClassName}>
            <div className="app-icon-container footer-left">
                <i className="app-icon"></i>
            </div>
            <span className="app-name footer-left"></span>
            <div className="version footer-left"><a href="#/changelog">{`v${props.version}`}</a></div>

            <a id="innsoft-button" href="http://www.innsoft.pl" target="_blank">
                <img
                    className="logo footer-right"
                    src="resources/images/innsoft_INNS.svg"
                    alt=""
                ></img>
            </a>
            <MediaQuery minWidth={!!props.expanded ? 1100 : 700}>
                <a
                    id="contact-button"
                    className="footer-right"
                    href="/#/contact"
                >
                    <Text value="CONTACT" />
                </a>
                <ServiceScreenButton></ServiceScreenButton>
                {/* <a
                    id="instruction-button"
                    className="footer-right"
                    href="/manual.pdf"
                    target="_blank"
                >
                    <Text value="INSTRUCTION" />
                </a> */}
            </MediaQuery>
            <LanguageSelector className="footer-right" />
            <MediaQuery maxWidth={!!props.expanded ? 1100 : 700}>
                <Dropdown drop="up">
                    <Dropdown.Toggle>
                        <i className="fas fa-ellipsis-h"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item href="/#/contact">
                            <Text value="CONTACT" />
                        </Dropdown.Item>
                        <Dropdown.Item href="/#/service">
                            <Text value="SERVICE" />
                        </Dropdown.Item>
                        {/* <Dropdown.Item href="/manual.pdf">
              <Text value="INSTRUCTION" />
            </Dropdown.Item> */}
                    </Dropdown.Menu>
                </Dropdown>
            </MediaQuery>
        </div>
    );
};
export default PageFooter;
